import { useState } from 'react';
import fuzzy from 'fuzzy';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import SelectionPanel from 'automation-ui-canvas/create/SelectionPanel';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ListMembershipTypeSelectionPanel({
  onClose,
  stagedTriggerOption,
  onSelectTriggerOption
}) {
  const [searchTerm, setSearchTerm] = useState('');
  const options = [{
    text: I18n.text('createWorkflow.listMembershipTypeSelectionPanel.addedToList'),
    value: 'IN_LIST'
  }, {
    text: I18n.text('createWorkflow.listMembershipTypeSelectionPanel.removedFromList'),
    value: 'NOT_IN_LIST'
  }];
  const searchResults = fuzzy.filter(searchTerm, options, {
    extract: ({
      text
    }) => text
  }).sort(({
    score: scoreA
  }, {
    score: scoreB
  }) => scoreB - scoreA).map(({
    original
  }) => original);
  return /*#__PURE__*/_jsx(SelectionPanel, {
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "createWorkflow.listMembershipTypeSelectionPanel.title"
    }),
    options: searchResults,
    searchTerm: searchTerm,
    onSearchTermChange: setSearchTerm,
    onClose: onClose,
    onSelectOption: ({
      value
    }) => {
      onSelectTriggerOption(Object.assign({}, stagedTriggerOption, {
        filters: [{
          filterType: 'IN_LIST',
          operator: value,
          listId: NaN
        }]
      }));
    }
  });
}